import { registerLocale, setDefaultLocale } from 'react-datepicker'
import * as Locales from 'date-fns/locale'
import useLocale from './useLocale'

const getDFNS = (culture) => {
  let code = culture
    .split('-')
    .map((part, index) => (index > 0 ? part.toUpperCase() : part))
    .join('')
  let locale = Locales[code]
  if (!locale) {
    code = code.substr(0, 2)
    locale = Locales[code]
  }
  return locale ? { code, locale } : null
}

const useDateLocale = (props = {}) => {
  const loc = useLocale()

  const { code, locale } =
    (props.locale ? getDFNS(props.locale) : undefined) ||
    getDFNS(loc.locale) ||
    getDFNS(loc.default) ||
    {}

  if (code) {
    registerLocale(code, locale)
    setDefaultLocale(code)
  } else {
    const err = new Error(`can't register locale`)
    if (Error.captureStackTrace) Error.captureStackTrace(err, useDateLocale)
    console.error(err)
  }

  return { dfns: code, locale }
}

export default useDateLocale
